@if (control) {
    <div class="sir-input-container" [ngClass]="{ 'has-value': control.value }">
        <input
            #input
            class="sir-text-style-paragraph-m-default"
            autocomplete="on"
            data-cy="input"
            [id]="id"
            [name]="name"
            [type]="type"
            [value]="value"
            [attr.data-identifier]="identifier"
            (focus)="focused.set(true)"
            (blur)="focused.set(false); onTouchedCallback()"
            (input)="onChange($event)"
            (change)="onChange($event)"
            [ngClass]="{
                'is-invalid': (valid$ | async) === false,
                'has-validator': control.validator,
            }" />
        @if (control.validator && control.value) {
            <!-- <div *ngIf="control.valid; else invalid" class="sir-icon sir-icon-valid">
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_627_450)">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M20.7803 6.22017C21.0732 6.51307 21.0732 6.98794 20.7803 7.28083L10.2803 17.7804C9.98743 18.0732 9.51259 18.0732 9.21969 17.7804L3.96969 12.5308C3.67679 12.238 3.67677 11.7631 3.96965 11.4702C4.26253 11.1773 4.7374 11.1773 5.03031 11.4701L9.74999 16.1894L19.7197 6.22015C20.0126 5.92726 20.4875 5.92727 20.7803 6.22017Z"
                        fill="#3C9D19" />
                </g>
                <defs>
                    <clipPath id="clip0_627_450">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </div>
        <ng-template #invalid> -->
            @if (!control.valid) {
                <div class="sir-input-status-icon is-invalid">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12Z"
                            fill="#D23A1D" />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12 6.75C12.4142 6.75 12.75 7.08579 12.75 7.5V12.75C12.75 13.1642 12.4142 13.5 12 13.5C11.5858 13.5 11.25 13.1642 11.25 12.75V7.5C11.25 7.08579 11.5858 6.75 12 6.75Z"
                            fill="#D23A1D" />
                        <path
                            d="M12 17.25C12.6213 17.25 13.125 16.7463 13.125 16.125C13.125 15.5037 12.6213 15 12 15C11.3787 15 10.875 15.5037 10.875 16.125C10.875 16.7463 11.3787 17.25 12 17.25Z"
                            fill="#D23A1D" />
                    </svg>
                </div>
                <!-- </ng-template> -->
            }
        }
        <sirius-label
            [for]="id"
            textStyle="system"
            [textStyleSize]="labelSize()"
            textStyleColor="secondary"
            [ngClass]="{ 'has-validator': control.validator }">
            {{ label }}
            @if (validationService.isRequired(control)) {
                <span class="sir-required-asterisk" aria-hidden="true">*</span>
            }
        </sirius-label>
    </div>
}
